<div class="loading-screen" [class.loading-screen--fade-out]="uiManagerService.fadingOut">
    <div class="loading-screen__content">
        <img class="loading-screen__logo" src="assets/img/blunt_loading.png" alt=""/>
        <div class="loading-wrapper">
            <div class="loading-screen__bar" *ngIf="!uiManagerService.loadingComplete">
                <div class="loading-screen__bar-fill" [style.width.%]="uiManagerService.progress || 0"></div>
            </div>
        </div>

        <div class="loading-wrapper" *ngIf="uiManagerService.loadingComplete">
            <button
                    class="loading-screen__play-btn"

                    (click)="uiManagerService.startGame()"
            >PLAY
            </button>
        </div>
    </div>

</div>
